import React from "react";
import type { OptionTs } from "@ps-bridge/interop";
import type { Ok } from "@ps-bridge/ok";
import SdeWorkbookUploadPanel, { type SdeWorkbookPhase } from "@view/panels/sde-workbook/SdeWorkbookUpload.panel";
import * as styles from "@styles/PageCounter.css";

export interface SdeWorkbookPagePanelProps {
  readonly programName: string;
  readonly phase: SdeWorkbookPhase;
  readonly selectedFile: OptionTs<File>;
  readonly message: string;
  readonly onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => Ok;
  readonly onSubmit: () => Promise<Ok>;
}

const SdeWorkbookPagePanel: React.FC<SdeWorkbookPagePanelProps> = ({
  programName,
  phase,
  selectedFile,
  message,
  onFileChange,
  onSubmit,
}) => (
  <section className={styles.page} data-testid="page-sde-workbook" data-page-state="ready" data-program={programName}>
    <div className={styles.shell}>
      <div className={styles.hero}>
        <p className={styles.eyebrow}>Income Recasting</p>
        <h1 className={styles.title}>Generate an SDE workbook from a tax return.</h1>
        <p className={styles.copy}>Upload the canonical DA2024-style PDF and download an XLSX with SDE default totals, EBITDA context, auto-suggested add-backs, evidence, provenance, review state, and disclaimers.</p>
      </div>
      <SdeWorkbookUploadPanel
        phase={phase}
        selectedFile={selectedFile}
        message={message}
        onFileChange={onFileChange}
        onSubmit={onSubmit}
      />
    </div>
  </section>
);

export default SdeWorkbookPagePanel;
